/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from 'react';
import { useState } from 'react';
import "./OscarCProfile.css";

function OscarCProfile() {

  const OscarCTours = [
    // {
    //   date: '2023-05-01',
    //   title: 'Tour 1',
    //   location: 'New York',
    //   ticketLink: 'https://example.com/tour-1-tickets',
    // },
    // {
    //   date: '2023-05-10',
    //   title: 'Tour 2',
    //   location: 'Los Angeles',
    //   ticketLink: 'https://example.com/tour-2-tickets',
    // },
    // {
    //   date: '2023-05-20',
    //   title: 'Tour 3',
    //   location: 'Chicago',
    //   ticketLink: 'https://example.com/tour-3-tickets',
    // },
  ];


  const formatDate = (dateString) => {
      const date = new Date(dateString);
      const month = date.toLocaleString('en-US', { month: 'short' });
      const day = date.getDate();
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    };
  const buyTicket = (tour) => {
    // alert(`Buying a ticket for ${tour.title} in ${tour.location} on ${tour.date}`);
    window.open(tour.ticketLink, '_blank');
  };

  

  /* Show More button Fuction */
  const [showFullBio, setShowFullBio] = useState(false);
  const handleToggleBio = () => {
    setShowFullBio(!showFullBio);
  };



  return (
    <div>
      <div className="OscarC-banner">
        {/* <img className="profile-pic" src="https://i1.sndcdn.com/artworks-000012755519-fd1mrr-t500x500.jpg" alt="Artist Profile" /> */}
      </div>
  {/* Artist's About Section*/}
  <div className="artist-info-container">
    <div className="artist-excerpt-container">
      <h1 className="entry-title">Oscar Calderon</h1>
        <p>
        Oscar Caladeron, comenzo su carrera musical a los lo años subiendo canciones a Youtube,
         canal que se popularizo rápidamente y que, debido al éxito, 
         comenzó a grabar comerciales para radio impulsando su experiencia profesional.
        </p>
    {showFullBio ? (
      <>
        {[      
        "Mas adelante, comienza un proyecto a dueto, lanzando, en el año de 2016, su primer EP compuesto por 4 canciones recibidas con gran aceptación del publico", 
        "Debido a lo anterior Oscar cuenta con s sencillos dentro de la agrupación y diversos shows abriendo los conciertos de artistas como Flans y Kalimba.",
        "Gracias a su virtuosismo vocal. participo como corista de Juan Gabriel, Prince Rovce, Emmanuel, Flans Daniel Boaventura, Eugenia Leon, Ana Barbara, entre muchos otros.",
        "Experiencia que lo llevo a estar firmado cor Ark Records como artista solista; lanzando bajo el sello de la empresa los sencillos 'La Faldita'. 'Si fuera por mi. 'Si tú me dejas' y 'La receta'.",
        "De forma independiente, produjo y compuso canciones para artistas como Edith Marque, Kalimba Alex Duran Fabiola Guaiardo entre otros.",
        "En 2022 lanza su propio sello OC Records y, actualmente, está a punto de lanzar su nuevo sencillo regional-urbano 'Con eso es suficiente' bajo su propia firma.",
      "",
      ""    
      ].map((text, index) => (
          <React.Fragment key={index}>
            {text.endsWith(".") ? (
              <>
                {text}
                <br />
              </>
            ) : (
              <>{text}</>
            )}
          </React.Fragment>
        ))}
        <button className="see-more" onClick={handleToggleBio}> Ver Menos</button>
      </>
    ) : (
      <button className="see-more" onClick={handleToggleBio}> Ver Mas</button>
    )}
        <div className="social-links">
          <a href="https://www.facebook.com/oscarcalderonmx" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://www.instagram.com/oscarcalderonmx/" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.youtube.com/channel/UCPblXiMJbfHIWLnTPj18ppg" rel="noopener noreferrer" target="_blank" className="artist-social-link">
            <i className="fab fa-youtube"></i>
          </a>
        </div>
      </div>
      <div className="artist-meta-container">
          <div className="artist-location artist-meta ">
              <h3>Ciudad</h3>
              <p>Chihuahua</p>
            </div>
            <div className="artist-genre artist-meta">
              <h3>Genero</h3>
              <p>Pop, Urbano y Regional</p>
            </div>
            <div className="artist-website artist-meta">
                <h3>Instagram</h3>
                <a href="https://www.instagram.com/oscarcalderonmx/"rel="noopener noreferrer" target="_blank">
                  <span>@OscarCalderonMx</span>
                </a>
            </div>
            <div className="artist-email artist-meta">
                <h3>Booking</h3>
                <a href="mailto: joe@masteredtrax.com" rel="noopener noreferrer">
                  <span>joe@masteredtrax.com</span>
                </a>
          </div>
      </div>
</div>
{/* Artist's Music Section*/}
  <div id='music'>
    <h1 className="music-section-title">MUSICA</h1>
    <div className="music-section">
      <div className="column youtube">
        <div className="music-wrap">
          <iframe
            title="YouTube Video"
            src="https://www.youtube.com/embed/zXDMt0YsbUg"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <div className="column spotify">
        <div className="music-wrap">
          <iframe
            title="Spotify Player"
            src="https://open.spotify.com/embed/artist/3s1IP7QMBQxcsCKwUi86iG?utm_source=generator&theme=0"
            width="100%"
            height="352"
            frameBorder="0"
            allowFullScreen=""
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>  
  </div>
{/* Artist's Tour Section*/}

<div id="tour">
        <h1 className="tour-section-title">TOUR</h1>
        {OscarCTours.length > 0 ? (
          <div className="tour-section">
            <table className="tour-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Título</th>
                  <th>Ubicación</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {OscarCTours.map((tour, index) => (
                  <tr key={index}>
                    <td id="event-date">{formatDate(tour.date)}</td>
                    <td id="event-title">{tour.title}</td>
                    <td id="event-location">{tour.location}</td>
                    <td id="button-container">
                      <button onClick={() => buyTicket(tour)}>Comprar boleto</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="tour-section">
            <p>No hay eventos programados.</p>
          </div>
        )}
      </div>
    </div>
  );
}
export default OscarCProfile;